import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Header = styled.div`
  text-align: ${(p) => p.$align || 'center'};
  margin-bottom: clamp(40px, 5vw, 56px);
`;

const Label = styled(motion.span)`
  display: block;
  font-family: var(--font-display);
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: ${(p) => (p.$dark ? '#6dbb1a' : '#0e6b3c')};
  margin-bottom: 14px;
`;

const Title = styled(motion.h2)`
  font-family: var(--font-display);
  font-size: clamp(2rem, 4.5vw, 2.75rem);
  font-weight: 800;
  margin-bottom: ${(p) => (p.$hasSubtitle ? '14px' : '0')};
  color: ${(p) => (p.$dark ? '#fff' : '#07111f')};
  letter-spacing: -0.03em;
  line-height: 1.15;

  .highlight {
    color: #0e6b3c;
  }
`;

const Subtitle = styled(motion.p)`
  font-size: 1.05rem;
  color: ${(p) => (p.$dark ? 'rgba(255,255,255,0.7)' : '#64748b')};
  max-width: 560px;
  margin: ${(p) => (p.$align === 'center' ? '0 auto' : '0')};
  line-height: 1.75;
`;

function renderTitle(title, titleHighlight) {
  if (!titleHighlight || !title.includes(titleHighlight)) return title;
  const parts = title.split(titleHighlight);
  return (
    <>
      {parts[0]}
      <span className="highlight">{titleHighlight}</span>
      {parts[1]}
    </>
  );
}

const SectionHeader = ({
  label,
  title,
  titleHighlight,
  subtitle,
  align = 'center',
  dark = false,
}) => {
  const anim = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
  };

  return (
    <Header $align={align}>
      {label && (
        <Label {...anim} transition={{ duration: 0.5 }} $dark={dark}>
          {label}
        </Label>
      )}
      <Title {...anim} transition={{ duration: 0.55, delay: 0.05 }} $hasSubtitle={!!subtitle} $dark={dark}>
        {renderTitle(title, titleHighlight)}
      </Title>
      {subtitle && (
        <Subtitle {...anim} transition={{ duration: 0.55, delay: 0.1 }} $align={align} $dark={dark}>
          {subtitle}
        </Subtitle>
      )}
    </Header>
  );
};

export default SectionHeader;
